<template>
  <div>
    <el-row class="search-box">
      <el-input v-model.trim="orderNo" placeholder="请扫服务单号" @keyup.enter="search" class="input"></el-input>
      <el-button :loading="loading" @click="search">查询</el-button>
      <KfMessage ref="searchMessage"/>
    </el-row>

    <el-card shadow="never" class="info-card">
      <el-row>
        <el-col :span="2" class="item-text">发货箱数：</el-col>
        <el-col :span="4" class="item-value">{{ repairReceive.send_box_cnt }}</el-col>
        <el-col :span="2" class="item-text">实际接收箱数：</el-col>
        <el-col :span="4" class="item-value">{{ repairReceive.receive_box_cnt }}</el-col>
        <el-col :span="2" class="item-text">服务单号：</el-col>
        <el-col :span="4" class="item-value">{{ repairReceive.order_no }}</el-col>
        <el-col :span="2" class="item-text">服务模式：</el-col>
        <el-col :span="4" class="item-value">{{ repairReceive.service_mode_name }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="2" class="item-text">外观损坏箱数：</el-col>
        <el-col :span="4" class="item-value">{{ repairReceive.box_ng_cnt }}</el-col>
        <el-col :span="2" class="item-text">接收人：</el-col>
        <el-col :span="4" class="item-value">{{ repairReceive.create_user_name }}</el-col>
        <el-col :span="2" class="item-text">接收时间：</el-col>
        <el-col :span="4" class="item-value">{{ repairReceive.create_time }}</el-col>
        <el-col :span="2" class="item-text">接收备注：</el-col>
        <el-col :span="4" class="item-value">{{ repairReceive.receive_remark }}</el-col>
      </el-row>
    </el-card>

    <FrameForm ref="frameForm" component-param="repair_box_check" :parent-data="{id:repairReceive.id}"></FrameForm>

  </div>
</template>

<script>
export default {
  name: "StationBoxCheck",
  data() {
    return {
      loading: false,
      orderNo: '',
      canWork: false,
      repairReceive: {}
    }
  },
  provide() {
    return {
      $fn: {
        reset: () => {
          this.orderNo = ''
          this.reset();
        }
      }
    }
  },
  methods: {
    search() {
      this.reset()
      this.$refs.frameForm.clearMessage()
      if (!this.orderNo) {
        return this.$refs.searchMessage.showError('服务单号不能为空')
      }

      this.loading = true
      this.$http('repairReceiveService.queryInfoForBoxCheck', {order_no: this.orderNo}, false).then(data => {
        this.loading = false
        this.repairReceive = data || {}
        this.canWork = true
        this.$refs.frameForm.initForm()

      }, errMsg => {
        this.loading = false
        return this.$refs.searchMessage.showError(errMsg)
      })

    },
    reset() {
      this.repairReceive = {}
      this.canWork = false
      this.$refs.searchMessage.clear()
    }
  }
}
</script>

<style lang="less" scoped>
.input {
  height: 32px;
  width: 250px;
  margin-right: 10px;
}

.search-box {
  padding-top: 10px;
  line-height: 40px;
  min-height: 50px;
}


.info-card {
  margin: 10px 0;

  .el-row {
    line-height: 32px;
    display: flex;
  }

  .item-text {
    text-align: right;
  }

  .item-value {
    color: goldenrod;
  }

  .item-value.red-tip {
    color: red;
  }
}


</style>